import { render, staticRenderFns } from "./baseproperty.vue?vue&type=template&id=2d067bbe&scoped=true&"
import script from "./baseproperty.vue?vue&type=script&lang=js&"
export * from "./baseproperty.vue?vue&type=script&lang=js&"
import style0 from "./baseproperty.vue?vue&type=style&index=0&id=2d067bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d067bbe",
  null
  
)

export default component.exports